import { FormlyModule } from '@ngx-formly/core';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

import { SnPlacesAutocompleteFormField } from './components/form-field/places-autocomplete.form-field';
import { SnPlacesAutocompleteControl } from './components/places-autocomplete/places-autocomplete.control';

@NgModule({
  imports: [
    // Angular
    FormsModule,
    CommonModule,

    // Material
    MatInputModule,

    // Formly
    FormlyModule.forChild({
      types: [
        {
          name: 'places-autocomplete',
          component: SnPlacesAutocompleteFormField,
          wrappers: ['form-field'],
        },
      ],
    }),
    ReactiveFormsModule,
  ],
  declarations: [SnPlacesAutocompleteFormField, SnPlacesAutocompleteControl],
  exports: [SnPlacesAutocompleteControl],
})
export class SnFormPlacesAutocompleteModule {}
